//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import 'jquery'
export default {
  mounted: function () {
    window.scrollTo(0, 0)
    var body = $('body')
    body.removeClass('scrollhidden')
  },
  methods: {
    selectCity: function (item) {
      this.selectCityItem = item
      if (item === '首页') {
        this.$destroy()
        this.$router.push({path: '/'})
      } else if (item === '产品介绍') {
        this.$destroy()
        this.$router.push({path: 'productinfo'})
      } else if (item === '联系我们') {
        this.$destroy()
        // this.$router.push({path: 'contact'})
      } else if (item === '新闻动态') {
        this.$destroy()
        this.$router.push({path: 'newDy'})
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Guanwang/Contact.vue